import React from 'react';
import { useParams } from 'react-router-dom';
import ListingForm from '../components/listings/ListingForm';

const EditListing: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <ListingForm mode="edit" listingId={id} />;
};

export default EditListing;
